import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { WorkspaceUserForTable } from '../../types'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_USERS_FOR_TABLE } from './api/query'
import { Data, Variables, WorkspaceUserForTableDTO } from './api/types'
import { UseGetWorkspaceUsers, UseGetWorkspaceUsersProps } from './types'

export const useGetWorkspaceUsers = ({
  filters,
  first,
  last,
}: UseGetWorkspaceUsersProps): UseGetWorkspaceUsers => {
  const { workspaceId } = useWorkspaceParam()
  const [users, setUsers] = useState<WorkspaceUserForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const {
        usersInWorkspace: { nodes: users, totalCount: count },
      } = data

      if (users) {
        setUsers(
          users.map((user: WorkspaceUserForTableDTO): WorkspaceUserForTable => fromDTO(user)),
        )
        setCount(count)
      }
    },
    query: GET_WORKSPACE_USERS_FOR_TABLE,
    variables: {
      first,
      last,
      terms: filters,
      workspaceId,
    },
  })

  return {
    count,
    loading: isLoading,
    users,
  }
}
